"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitAddress = submitAddress;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _models = require("../models");
async function submitAddress(api, customerId, requestData, action) {
  try {
    if (action === 'createAddress') {
      const response = await (0, _globalApiClientReact.createCustomerAddress)(api, customerId, requestData);
      const {
        status,
        data
      } = response;
      return new _models.FetchResult(status, data);
    } else if (action === 'updateAddress') {
      const addressId = (requestData.addressId ?? '').toString();
      const response = await (0, _globalApiClientReact.updateCustomerAddress)(api, customerId, addressId, requestData);
      const {
        status,
        data
      } = response;
      return new _models.FetchResult(status, data);
    }
  } catch (error) {
    if (error instanceof _globalApiClientReact.AxiosError && error.response) {
      return new _models.FetchResult(error.response.status, error.response.data);
    }
    return _models.FetchResult.error;
  }
  return _models.FetchResult.error;
}
//# sourceMappingURL=submitAddress.js.map